import React from 'react';
import './Footer.css';

const QUICK_LINKS = [
  { label: 'Home',            href: '#home' },
  { label: 'About Us',        href: '#about' },
  { label: 'Notices Board',   href: 'notices' },
  { label: 'Question Papers', href: 'question-papers' },
  { label: 'Blogs & Articles',href: 'blogs' },
];

const SUPPORT_LINKS = [
  { label: 'Notices Board',      href: 'notices',         icon: 'fa-solid fa-bell' },
  { label: 'Question Papers',    href: 'question-papers',  icon: 'fa-solid fa-file-lines' },
  { label: 'Blogs & Articles',   href: 'blogs',           icon: 'fa-solid fa-rss' },
];

const CONTACT = [
  { icon: 'fa-solid fa-location-dot', text: 'Amardeep Singh Shergill Memorial College, Mukandpur, Punjab - 144507' },
  { icon: 'fa-solid fa-phone',        text: '+91 1823 276221' },
  { icon: 'fa-solid fa-envelope',     text: 'library@assmcollegemukandpur.org' },
  { icon: 'fa-regular fa-clock',      text: 'Mon–Sat: 9:00 AM – 4:00 PM' },
];

const SOCIALS = [
  { icon: 'fa-brands fa-facebook-f',  href: '#', label: 'Facebook' },
  { icon: 'fa-brands fa-x-twitter',   href: '#', label: 'Twitter/X' },
  { icon: 'fa-brands fa-instagram',   href: '#', label: 'Instagram' },
  { icon: 'fa-brands fa-youtube',     href: '#', label: 'YouTube' },
  { icon: 'fa-brands fa-linkedin-in', href: '#', label: 'LinkedIn' },
];

export default function Footer({ onNavigate }) {
  const year = new Date().getFullYear();

  const handleLinkClick = (e, href) => {
    if (href === 'question-papers' || href === 'notices' || href === 'blogs') {
      e.preventDefault();
      onNavigate?.(href);
      window.scrollTo(0, 0);
      return;
    }

    e.preventDefault();
    onNavigate?.('home');

    // Scroll to section after a tiny delay if transitioning back to home
    setTimeout(() => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    onNavigate?.('home');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="footer">

      {/* ── Wave top decoration ── */}
      <div className="footer__wave">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
            fill="#0e0f2e"
          />
        </svg>
      </div>

      <div className="footer__body">
        <div className="footer__inner">

          {/* ── Col 1: Brand ── */}
          <div className="footer__col footer__col--brand">
            <a href="#home" onClick={handleLogoClick} className="footer__logo">
              <img src="/logo.png" alt="Dr. SS Johl Library" />
            </a>
            <p className="footer__tagline">
              Dr. SS Johl Library, ASSM College, Mukandpur.
              Empowering minds through knowledge — your trusted academic partner
              supporting scholarly excellence.
            </p>

            {/* Social icons */}
            <div className="footer__socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="footer__social-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>

            {/* Hours highlight */}
            <div className="footer__hours-pill">
              <i className="fa-solid fa-circle footer__hours-dot"></i>
              <span>Open Today · 9 AM – 4 PM</span>
            </div>
          </div>

          {/* ── Col 2: Quick Links ── */}
          <div className="footer__col">
            <h4 className="footer__col-title">
              <span className="footer__col-title-bar" />
              Quick Links
            </h4>
            <ul className="footer__list">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="footer__link"
                    onClick={(e) => handleLinkClick(e, link.href)}
                  >
                    <i className="fa-solid fa-chevron-right footer__link-chevron"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 3: Student Support ── */}
          <div className="footer__col">
            <h4 className="footer__col-title">
              <span className="footer__col-title-bar" />
              Student Support
            </h4>
            <ul className="footer__list footer__list--icons">
              {SUPPORT_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="footer__link footer__link--icon"
                    onClick={(e) => handleLinkClick(e, link.href)}
                  >
                    <span className="footer__link-icon-box">
                      <i className={link.icon}></i>
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 4: Contact ── */}
          <div className="footer__col">
            <h4 className="footer__col-title">
              <span className="footer__col-title-bar" />
              Contact Us
            </h4>
            <ul className="footer__contact-list">
              {CONTACT.map((item, i) => (
                <li key={i} className="footer__contact-item">
                  <div className="footer__contact-icon">
                    <i className={item.icon}></i>
                  </div>
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>

            {/* Map embed placeholder */}
            <div className="footer__map-pill">
              <i className="fa-solid fa-map-location-dot"></i>
              <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">
                View on Google Maps
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p className="footer__copy">
            © {year} Dr. SS Johl Library, ASSM College Mukandpur. All rights reserved.
            <span className="footer__copy-divider">·</span>
            Supporting university examinations & learning.
          </p>
        </div>
      </div>

    </footer>
  );
}
